import React from 'react';
import { BrandPanel } from './BrandPanel';
import { DevEnvToggle } from './DevEnvToggle';
import { KGMark } from './icons';
import { useAuth } from './useAuth';
import './AuthForm.css';

interface AuthFormProps {
  onAuthenticated: () => void;
}

const AuthForm: React.FC<AuthFormProps> = ({ onAuthenticated }) => {
  const { showEnvToggle, selectedEnv, setSelectedEnv, redirecting, triggerRedirect } = useAuth(onAuthenticated);

  const envLabel = selectedEnv === 'testpolly' ? 'Testpolly' : selectedEnv === 'devpolly' ? 'Devpolly' : 'Polly';

  return (
    <div className="lp-root">
      <BrandPanel />
      <main className="lp-auth">
        <div className="lp-auth__card">
          <div className="lp-auth__logo">
            <div className="lp-auth__logo-mark">
              <KGMark size={40} />
            </div>
            <div className="lp-auth__logo-text">
              <span className="lp-auth__logo-kg">KG</span>
              <span className="lp-auth__logo-mgr"> Manager</span>
            </div>
          </div>

          <div className="lp-auth__head">
            <h2 className="lp-auth__title">Connect to Polly</h2>
            <p className="lp-auth__desc">
              Sign in with your Polly account to continue.
            </p>
          </div>

          {showEnvToggle && (
            <DevEnvToggle
              value={selectedEnv}
              onChange={setSelectedEnv}
              disabled={redirecting}
            />
          )}

          <button
            className="lp-auth__submit"
            onClick={triggerRedirect}
            disabled={redirecting}
          >
            {redirecting ? 'Redirecting…' : `Login with ${envLabel}`}
          </button>
        </div>
      </main>
    </div>
  );
};

export default AuthForm;
